var React = require('react');

function CheckMark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.61401 7.80408L0.200339 4.47067C-0.0667796 4.20983 -0.0667796 3.78857 0.200339 3.52815C0.467457 3.26731 0.898858 3.26731 1.16555 3.52815L4.07061 6.36491L9.73392 0.220224C9.98653 -0.0522846 10.4179 -0.0756132 10.6979 0.171055C10.9778 0.416896 11.0004 0.838571 10.7482 1.11233L4.6036 7.77916C4.47857 7.915 4.30106 7.99458 4.11416 8H4.09624C3.85585 7.90168 3.7416 7.9295 3.61401 7.80408Z","fill":"#685F56"}));
}

CheckMark.defaultProps = {"width":"11","height":"8","viewBox":"0 0 11 8","fill":"none"};

module.exports = CheckMark;

CheckMark.default = CheckMark;
